import store from '@/store/index';
import { BaseSubject } from '../BaseSubject.model';
import { PADDING_TOP, PAGE_SIZE_CELL } from '@/subjects/constant';
import { getContentWidth } from '@/utils/contentWidth';
import { textSize } from '../../utils/textSize';
const ANSWER_HEIGHT_AND_TH = 340; //解答题默认高度
let ANSWER_HEIGHTH = 300; //解答题默认高度 默认给 2行
//@ts-ignore
let answerPanelState = store.state.answerPanel;
const TH_HEIGHT = 40; //标题高度
const MARGIN_BOTTOM = 10; // 每个页面底部空白的高度值为10px
const TAG_P_HEIGHT = 38; // 一个p元素的固定高度
export const XTH_TYPE_KONG = '(空)';
const XTH_TYPE_NUMBER = '①';
const XTH_TYPE_EN = 'a';
const XTH_TYPE_I = 'Ⅰ';
interface XTHItem {
  //小题号item
  label: string;
  value: string;
}
interface XThType {
  '①': Array<string>;
  a?: Array<string>;
  Ⅰ?: Array<string>;
  '(空)'?: any;
  '(1)'?: any;
}
/**
 * 解答题
 */
export class AnswerModel extends BaseSubject {
  static xThType: XThType | any = {
    '(空)': [],
    '①': ['①', '②', '③', '④', '⑤', '⑥', '⑦', '⑧', '⑨', '⑩'],
    a: ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l'],
    Ⅰ: ['Ⅰ', 'Ⅱ', 'Ⅲ', 'Ⅳ', 'Ⅴ', 'Ⅵ', 'Ⅶ', 'Ⅷ', 'Ⅸ', 'Ⅹ', 'Ⅺ', 'Ⅻ'],
    '(1)': ['(1)', '(2)', '(3)', '(4)', '(5)', '(6)', '(7)', '(8)', '(9)', '(10)', '(11)', '(12)'],
  };

  /**
   * 通用显示行数
   */
  rowNum: any;

  /**
   * 一个解答题的高度
   * */
  groupHeight: any;

  /**
   * 生成解答题合集
   * */
  //@ts-ignore
  htmlArray: any[];
  currentPage?: number;
  xTHValue: string = '(空)'; // 小题号的值 小题号默认为空 如果是空则代表没有小题号
  xThs: Array<XTHItem> = [
    { label: '(空)', value: '(空)' },
    { label: '(1)', value: '(1)' },
    { label: '①', value: '①' },
    { label: 'Ⅰ', value: 'Ⅰ' },
    { label: 'a', value: 'a' },
  ]; // 小题号默认的列表
  hasUnderLine: boolean = false; // 是否会下划线
  lineNum:number = 2;
  constructor(obj?: {
    name?: string;
    start?: any;
    end?: any;
    score?: any;
    value?: any;
    th?: any;
    items?: any[];
    htmlArray?: [];
    innerHTML?: string;
    rowNum?: any;
    groupHeight?: any;
    totalScore?: number;
    hasUnderLine?: boolean,
    lineNum?: any,
  }) {
    super(obj);
    obj = obj || {};
    this.type = 3; // 解答题标识
    this.name = obj.name || '解答题';
    this.innerHTML = obj.innerHTML || undefined;
    this.htmlArray = obj.htmlArray || [];
    this.rowNum = obj.rowNum || 8; // 默认展示8个行数
    this.groupHeight = obj.groupHeight || 200; // 默认展示200像素高度
    this.totalScore = obj.totalScore || 0;
    this.hasUnderLine = obj.hasUnderLine || false; // 是否有下划线
    this.lineNum = obj.lineNum || 2;

    // 需要下划横线时 显示2行
    ANSWER_HEIGHTH = obj.hasUnderLine ? 100 : ANSWER_HEIGHT_AND_TH;
    //
    if (obj.items && obj.items.length) {
      this.items = obj.items;
    } else {
      this.innerHTML = obj.innerHTML;
      this.totalScore += obj.score;
      for (let idx = obj.start; idx <= obj.end; idx++) {
        if(obj.items){
          this.lineNum = obj.items[idx].lineNum;
        }
        obj.items &&
          this.items.push({
            no: idx,
            score: obj.score,
            value: obj.score, // 保留字段
            lineNum: this.lineNum
          });
      }
    }

  }

  render(options: any = {}) {
    console.log('render=======================');
    
    const { hurdleReset } = options; // 不是通过二栏三栏render的
    const items = this.items;
    this.computedScoreAndTH();
    const htmlArray = [];
    for (let index = 0; index < items.length; index++) {
      const item = items[index];

      let rows = [];
      // for (let i = 0; i < 4; i++) {
      //   rows.push(i === 0 ? `<p>${item.no}.(${item.score}分)</p>` : `<p></p>`);
      // }

      if (this.hasUnderLine) {
        let lines = this.evergeRender(options, item)
        rows = [lines]
        
        
      } else {
        rows.push(
          `<p class='row'>${item.no}.${item.xth || ''}<span class='score'>(${item.score
          }分)</span>&nbsp;</p>`
        );
      }
      htmlArray.push({
        no: item.no,
        xth: item.xth || '',
        isEdit: false,
        innerHTML: rows.join(''),
        rows,
      });
    }
    // 3 表示解答题
    if (!hurdleReset && this.htmlArray.length && !this.fromEdit) {
    } else {
      this.htmlArray = htmlArray;
    }
  }

  computedScoreAndTH(unComputedTH?: boolean) {
    this.totalScore = 0;
    this.items.forEach(item => {
      this.totalScore! += Number(item.score);
    });
    if (unComputedTH) {
      return;
    }
    if (this.items.length > 1) {
      this.start = this.items[0].no;
      this.end = this.items[this.items.length - 1].no;
    } else {
      this.start = (this.items[0] && this.items[0].no) || 0;
      this.end = (this.items[0] && this.items[0].no) || 0;
    }
  }
  // 追加
  addItems(obj: any) {
    this.addXthItems(obj);
    this.addNoXthItems(obj);

    // this.items.sort((a: any, b: any) => {
    //   return a.no - b.no;
    // });
  }

  /**
   *
   * push 有小题号的数组item 就是题型设置的时候 小题号设置不为空
   * @param obj
   */
  addXthItems(obj: any): void {
    if (obj.xTHValue !== XTH_TYPE_KONG) {
      for (let idx = Number(obj.start); idx <= Number(obj.end) - 1 + Number(obj.start); idx++) {
        obj.items &&
          this.items.push({
            no: obj.start,
            xth:
              (AnswerModel.xThType[obj.xTHValue].length &&
                AnswerModel.xThType[obj.xTHValue][idx - obj.start]) ||
              '',
            score: obj!.score,
            value: idx,
            lineNum: this.lineNum,
          });
      }
    }
  }

  /**
   * push 没有小题号的数组item 就是题型设置的时候 小题号设置为空
   * @param obj
   */
  addNoXthItems(obj: any): void {
    // const hash: any = {};
    if (obj.xTHValue === XTH_TYPE_KONG) {
      for (let idx = Number(obj.start); idx <= Number(obj.end); idx++) {
        obj.items &&
          this.items.push({
            no: idx,
            xth: '',
            score: obj!.score,
            value: idx,
            lineNum: this.lineNum,
          });
      }
      // this.items = this.items.reduce((item: any, next: any) => {
      //   hash[next.no] ? '' : (hash[next.no] = true && item.push(next));
      //   return item;
      // }, []); // 对象数组去重
    }
  }

  deleteItem(index: number) {
    this.items.splice(index, 1);
    this.computedScoreAndTH(true);
  }

  appendToPage(state: any, pageHeight: number, newTopicHeight: number): void {
    let { acCardYJType } = answerPanelState.answerSheet;
    let cardGapHeight = acCardYJType == 2 ? 34 : 0
    let scoreTotalHeight = 0
    state.answerTopicAdded = []; //将之前新增的解答题清空
    state.answerSignal = true;
    state.newTopicHeight = 0;
    console.log('appendToPage appendToPage appendToPage======',state,this.htmlArray);
    this.htmlArray.forEach((html, index) => {
      // state.pageCell[state.pageCell.length - 1].items.push(this.);
      state.answerTopicAdded.push({
        ...html,
        no: html.no,
        name: html.name || this.name,
        totalScore: this.totalScore,
        start: html.start || this.start,
        end: html.end || this.end,
        th: html.th || this.th,
        xth: (this.items[index] && this.items[index].xth) || '',
        hasTitle: index == 0 ? true : undefined,
        type: html.type || this.type,
        initDragHeight: this.hasUnderLine ? this.items[index].lineNum * TAG_P_HEIGHT  + MARGIN_BOTTOM + 15 : (html.initDragHeight || ANSWER_HEIGHTH),
        isHurdle: false,
        // 初始化拖拽高度（如果是弹窗生成的题目高度是由数据生产者计算编辑器空格生成的高度，不需要initDragHeight，如果是拖拽生成的高度就是这个属性）
        innerHTML: html.innerHTML,
        hasUnderLine: this.hasUnderLine
      });
      state.newTopicHeight += ((this.hasUnderLine ? this.items[index].lineNum * TAG_P_HEIGHT + MARGIN_BOTTOM + 15  : (html.initDragHeight || ANSWER_HEIGHTH)) + cardGapHeight); // 算上标题的总高度
      scoreTotalHeight += cardGapHeight
    });

    // state.newTopicHeight = state.newTopicHeight + TH_HEIGHT;
    let currentPage = state.pageCell.length - 1;
    if (this.page.isSurplusPage(state, currentPage, TH_HEIGHT + TAG_P_HEIGHT + MARGIN_BOTTOM)) {
      // state.newTopicHeight = this.htmlArray.length * ANSWER_HEIGHTH + TH_HEIGHT; // 算上标题的总高度
      let cloneTopicList = JSON.parse(
        JSON.stringify(state.pageCell[state.pageCell.length - 1].fillTopiclist)
      );
      cloneTopicList = [...cloneTopicList, ...state.answerTopicAdded];
      // state.answerTopicAdded.forEach((answerTopic: any) => {
      //   state.pageCell[state.pageCell.length - 1].fillTopiclist.push(answerTopic);
      // });
      this.currentPage = state.pageCell.length - 1;
      this.recursionCutAnswerPage(
        state,
        currentPage,
        state.existHeight + TH_HEIGHT,
        undefined,
        false
      ); // 这里已存在的高度加上TH_HEIGHT是因为 算解答题总高度的时候没有加上题号高度
    } else {
      this.page.createNextPage(state.pageCell);
      currentPage++;
      // state.newTopicHeight = this.htmlArray.length * ANSWER_HEIGHTH + TH_HEIGHT; // 算上标题的总高度
      // state.pageCell[currentPage].fillTopiclist = [
      //   ...state.pageCell[currentPage].fillTopiclist,
      //   ...state.answerTopicAdded,
      // ];
      this.currentPage = state.pageCell.length - 1;
      this.recursionCutAnswerPage(state, currentPage, TH_HEIGHT, undefined, false);
    }
    // throw new Error('Method not implemented.');
  }
  /** 横线解答题 */
  // 均分
  evergeRender(options: any = {}, item) {
    
    let lineNum = null;
    if(item.lineNum && item.lineNum > 0){
      lineNum = item.lineNum
    }else{
      lineNum = this.lineNum
    }
    this.lineNum = lineNum
    console.log('evergeRender evergeRender:::lineNum::::',lineNum,this.lineNum)
    const { hurdleReset, eachBlankScore } = options; // 不是通过二栏三栏render的
    // var container: any = document.querySelector('.basics');
    // var containerWidth: any = container.offsetWidth - 24 - 42,
    this.computedScoreAndTH();
    let nbNode = document.querySelector('.text-size-dom')
    let nbWidth = nbNode ? nbNode.getBoundingClientRect().width : 0
    this.computedScoreAndTH();
    var nbSize = textSize('&nbsp;'); // 360安全浏览器 计算的是4 谷歌及360极速浏览器（谷歌内核）计算的是4.21875
    nbSize = nbWidth || 4.41875 || Math.floor(nbSize);
    var containerWidth = getContentWidth(); // 获取容器宽度
    let rows: any[] = [];

    for (let index = 0; index < lineNum; index++) {
      // let item = this.items[index],
      //   itemPrev = this.items[index - 1],
      let itemColumnValue = 2, // 每题两空
        // 这里改成题号 小题号固定宽度 是为了 填空题增添每题给分的时候固定位置统一
        thStr = `<span style="min-width: 46.8px;display: inline-block">${item.no + '.'}${item.xth || ''}&nbsp;&nbsp;</span>`;
      // thStr = `${item.no + '.'}${item.xth || ''}&nbsp;&nbsp;`
      let thWidth = textSize(thStr);
      for (let x = 0; x < itemColumnValue; x++) {
        var columnHtml = '',
          nbCount = 0;
        // 每空长度  = 均分长度 - 公摊部分（小题号占用空间 + 末尾换行）
        let width = containerWidth - thWidth - (index == 0 ? 12 + 2 * nbWidth : 12);
        nbCount = Number(Math.floor((width ) / nbSize)) + (!index ? 0 : Number(Math.floor((thWidth - 10 ) / nbSize)))
        //          
        if (!x) {
          columnHtml = thStr + `<span style="margin-right:  0px;text-decoration: underli ne;font-family: '宋体' !important; position: static}">&#8203;`;
          // nbCount = Math.floor((columnWidth - thWidth) / nbSize) - 3;
        } else {
          // 这里改成题号 小题号固定宽度 是为了(eachBlankScore为true 添加每题给分) 填空题增添每题给分的时候固定位置统一
          columnHtml = `<span style="margin-right: 0px;text-decoration: underline;font-family: '宋体' !important;">&#8203;`;
        }
      }
      console.log('nbCount====log=======', nbCount);
      
      for (let y = 0; y < nbCount; y++) {
        columnHtml += '&nbsp;';
      }
      columnHtml += `</span>`;
      rows.push([columnHtml]);

    }    
    //
    let html = `<p class='row'>${item.no}.${item.xth || ''}<span class='score'>(${item.score
      }分)</span>&nbsp;${rows
        .map((r: any) => r.join(''))
        .join('</p><p class="row row-blank" style="font-family: arial;">')}</p>`;
    return html
    
    // 这里this.innerHTML有三种i情况 1是第一次初始化 的确需要赋值  2是自定义编辑之后render方法执行 这里的this.innerHTML用已经存储的this.innerHTML
    // 这里最重要注意的就是 如果来自编辑的是当前的题型 字段fromEdit判断是否是当前编辑的 则不可能保存之前的高度和html 只能重新更新题型
    // if (!hurdleReset && this.innerHTML && this.innerHTML.length && !this.fromEdit) {
    //   // this.cacheInnerHTML = this.innerHTML;
    //   return console.log('当前html有值的情况', this.innerHTML);
    // } else {
    //   this.innerHTML = `<p class='row'>${rows
    //     .map((r: any) => r.join(''))
    //     .join('</p><p class="row">')}</p>`;
    //   // this.rowCount = this.rows.length;
    // }
  }

  /**
   * 
   * @param state 
   */
  resetPage(state: any,) {
    console.log('resetPage=======answer', state)
    
    let currentPage = state.pageCell.length - 1;
    if (this.page.isSurplusPage(state, currentPage, TH_HEIGHT + TAG_P_HEIGHT + MARGIN_BOTTOM)) {
      // state.newTopicHeight = this.htmlArray.length * ANSWER_HEIGHTH + TH_HEIGHT; // 算上标题的总高度
      let cloneTopicList = JSON.parse(
        JSON.stringify(state.pageCell[state.pageCell.length - 1].fillTopiclist)
      );
      cloneTopicList = [...cloneTopicList, ...state.answerTopicAdded];
      // state.answerTopicAdded.forEach((answerTopic: any) => {
      //   state.pageCell[state.pageCell.length - 1].fillTopiclist.push(answerTopic);
      // });
      this.currentPage = state.pageCell.length - 1;
      this.recursionCutAnswerPage(
        state,
        currentPage,
        state.existHeight + TH_HEIGHT,
        undefined,
        false
      ); // 这里已存在的高度加上TH_HEIGHT是因为 算解答题总高度的时候没有加上题号高度
    } else {
      this.page.createNextPage(state.pageCell);
      currentPage++;
      // state.newTopicHeight = this.htmlArray.length * ANSWER_HEIGHTH + TH_HEIGHT; // 算上标题的总高度
      // state.pageCell[currentPage].fillTopiclist = [
      //   ...state.pageCell[currentPage].fillTopiclist,
      //   ...state.answerTopicAdded,
      // ];
      this.currentPage = state.pageCell.length - 1;
      this.recursionCutAnswerPage(state, currentPage, TH_HEIGHT, undefined, false);
    }
  }
  /**
   * 解答题递归更新纸张高度
   */
  /**
   * 解答题递归更新纸张高度
   */
  recursionCutAnswerPage(
    state: any,
    currentPage: number,
    existHeight: number,
    currentTopicStackList: any,
    isSellCall: boolean
  ) {
    // 这里可以将数据遍历好之后一次性赋值给store 然后更新视图
    // currentTopicStackList =
    //   currentTopicStackList ||
    //   this.currentTopicStackList.filter(topic => {
    //     return topic.type === 3;
    //   });
    currentTopicStackList = JSON.parse(
      JSON.stringify(currentTopicStackList || state.answerTopicAdded)
    );
    // existHeight = existHeight  + answerArray ? cardGapHeight * (answerArray.length || 1) : cardGapHeight ;      
    // currentTopicStackList = JSON.parse(JSON.stringify(currentTopicStackList));
    const currentMaxHeight = state.pageCell[currentPage].contentHeight;
    const canFillHeight = currentMaxHeight - existHeight; // 可填充高度
    let topicHeight = state.newTopicHeight;
    if (topicHeight > canFillHeight) {
      // 当有存在高度的时候 大于存在高度跨栏 topicHeight减去填充高度 超出高度insert下一页 循环
      let newFillTopicList = [];
      topicHeight -= isSellCall ? currentMaxHeight : canFillHeight;
      // topicHeight -= canFillHeight;
      // 当上面没有已存在的高度可以直接减去currentMaxHeight
      // topicHeight -= currentMaxHeight; // 当上面没有已存在的高度可以直接减去currentMaxHeight
      // topicHeight -= canFillHeight; // 当上面没有已存在的高度可以直接减去currentMaxHeight
      // 这里要注意只有当前第一次遍历的时候题型是有头部高度的 canFillHeight需要减去头部题号高度然后在取余
      let yushuHeight = 0;
      let zhengshuHeight = 0;
      // if (!isSellCall) {
      //   // 这里如果编辑之后的解答题 高度会随着变化 所以这边的ANSWER_HEIGHTH300px不能固定除法 所以这边需要除以自定义编辑之后的高度
      //   yushuHeight = (canFillHeight - TH_HEIGHT) % ANSWER_HEIGHTH; //取余 这里第一次递归是要去除解答题的头部高度40px的
      //   zhengshuHeight = Math.floor((canFillHeight - TH_HEIGHT) / ANSWER_HEIGHTH); //取整
      // } else {
      //   yushuHeight = canFillHeight % ANSWER_HEIGHTH; //取余
      //   zhengshuHeight = Math.floor(canFillHeight / ANSWER_HEIGHTH); //取整
      // }

      const surplusInfo = this.surplusHeightComputed(canFillHeight, currentTopicStackList);
      yushuHeight = surplusInfo.topHeight || 0;
      zhengshuHeight = surplusInfo.fillIndex || 0;
      state.newTopicHeight = topicHeight;
      newFillTopicList = currentTopicStackList.splice(
        // 如果当前的解答题已经生成了 后面还是新增的解答题的话
        // 这边filter筛选就要把之前的解答题去除掉再push
        zhengshuHeight
        // currentTopicStackList.length - 1
      );
      // this.removeSurplusStackWhenFirstInitCurtPage(state, currentPage); //当初第一是初始化list的时候移除超出的题型（就是对新增的题型重造）
      currentTopicStackList.forEach((item: any, index: number) => {
        // 将当前元素重新push到state.page当中去
        if (index == currentTopicStackList.length - 1) {
          // 最后的题型stack 就是余数多出的部分
          if (surplusInfo.topHeight < TAG_P_HEIGHT && surplusInfo.topHeight > 0) {
            // state.newTopicHeight =
            //   state.newTopicHeight + canFillHeight - (surplusInfo.topicTotalFillHeight || 0);
            // newFillTopicList.unshift(currentTopicStackList[currentTopicStackList.length - 1]);
            // state.pageCell[currentPage].fillTopiclist.push(item);
          } else if (surplusInfo.topHeight <= 0) {
            // 说明最后可填充高度canFillHeight一直大于剩余的题型高度 直接push到栈未
            state.pageCell[currentPage].fillTopiclist.push(item);
          } else {
            surplusInfo.topHeight && surplusInfo.topHTML && state.pageCell[currentPage].fillTopiclist.push({
              th: this.th,
              ...item,
              isHurdle: true,
              initDragHeight: surplusInfo.topHeight, //不需要减去题号高度了 因为解答题不需要题号
              innerHTML: surplusInfo.topHTML, // surplusInfo.topHeight并且surplusInfo.html有内容的时候 才可以头部加入stack题型
              // innerHTML: surplusInfo.topHTML || currentTopicStackList[currentTopicStackList.length - 1].innerHTML,
            });
          }
        } else {
          state.pageCell[currentPage].fillTopiclist.push(item);
        }
      });
      if ((surplusInfo.topHeight <= 0 || surplusInfo.bottomHeight <= TAG_P_HEIGHT) && state.newTopicHeight <= TAG_P_HEIGHT) {
        // 解决多出的高度很小的问题
        return;
      }
      if (surplusInfo.topHeight == 0 && surplusInfo.bottomHeight == 0) {
        return; // 特殊情况
      }
      this.page.createNextPage(state.pageCell);
      currentPage++;
      const lastStack = currentTopicStackList[currentTopicStackList.length - 1];
      if (surplusInfo.topHeight < TAG_P_HEIGHT + MARGIN_BOTTOM && surplusInfo.topHeight > 0) {
        // 解答题分解递归跨栏换页的时候 如果剩下的高度不足以 题号高度的话 递归下一页的时候 已存在高度应该是0
        const existHeight = 0;
        this.insertNextPageHeadStack(
          lastStack && lastStack.no,
          state.pageCell[currentPage],
          surplusInfo.topHeight + surplusInfo.bottomHeight,
          lastStack && lastStack.innerHTML,
          lastStack && lastStack.xth,
          { isSub: false },
          lastStack
        );
        // 这里的exitHeight应该是不足当前页的题型全部分解到下一页头部的题型高度
        this.recursionCutAnswerPage(
          state,
          currentPage,
          surplusInfo.topHeight + surplusInfo.bottomHeight,
          newFillTopicList,
          true
        );
        // this.recursionCutAnswerPage(state, currentPage, 0, newFillTopicList, true);
      } else if (surplusInfo.topHeight < 0) {
        return;
      } else {
        this.insertNextPageHeadStack(
          lastStack && lastStack.no,
          state.pageCell[currentPage],
          surplusInfo.bottomHeight,
          surplusInfo.bottomHTML || undefined,
          lastStack && lastStack.xth,
          surplusInfo.topHTML == '' ? { isSub: false } : { isSub: true },
          surplusInfo.topHTML == '' ? lastStack : {}
        );
        this.recursionCutAnswerPage(
          state,
          currentPage,
          // + ((surplusInfo.topHTML== '' && !isSellCall) ? TH_HEIGHT : 0) 加上这个是因为 底部高度不足直接跨栏显示的时候已存在高度是要加上头部题号高度的
          surplusInfo.bottomHeight + ((surplusInfo.topHTML == '' && !isSellCall) ? TH_HEIGHT : 0),
          newFillTopicList,
          true
        );
      }

      // }
    } else {
      // const yushuHeight = topicHeight % ANSWER_HEIGHT_AND_TH; //取余
      // const zhengshuHeight = parseInt(canFillHeight / ANSWER_HEIGHT_AND_TH); //取整
      // if (currentPage === this.currentPage) {
      //   // 说明新增加的高度没有超过当前maxHeight
      // } else {
      currentTopicStackList.forEach((item: any) => {
        state.pageCell[currentPage].fillTopiclist.push(item);
      });
      // }

      // state.loadingInstance.close();
      return console.log('停止递归', topicHeight, canFillHeight);
    }
  }

  /**
   * 剩余/可填充高度高度计算
   */
  surplusHeightComputed(canFillHeight: number, currentTopicStackList: any) {
    let topicTotalHeight = 0;
    let topicTotalFillHeight = 0; //可填充的高度
    let fillIndex = 0; // 填充当前的下标
    let bottomHeight = -1; // 填充高度之后多余底部高度
    let bottomElsHeight = 0;
    let topHeight = -1; // 填充高度之后多余头部高度
    let bottomHTML = '';
    let topHTML = '';
    // 打分模式下需要计算高度
    let { acCardYJType } = answerPanelState.answerSheet;
    let cardGapHeight = acCardYJType == 2 ? 34 : 0

    for (let i = 0; i < currentTopicStackList.length; i++) {
      topicTotalHeight += (currentTopicStackList[i].initDragHeight + cardGapHeight);
      if ((canFillHeight) > topicTotalHeight) {
        fillIndex = i + 1; // 这里+1是因为这个下标拿到之后 需要splice(index+1)切割然后分解题型需要
        topicTotalFillHeight += currentTopicStackList[i].initDragHeight;
        topHeight = 0;
        bottomHeight = 0;
      } else {
        fillIndex = i + 1; // 这里+1是因为这个下标拿到之后 需要splice(index+1)切割然后分解题型需要
        // if(canFillHeight - topicTotalFillHeight < TAG_P_HEIGHT +MARGIN_BOTTOM) {
        //   bottomHeight = 300;
        //   topHeight = 1;
        // } else {
        bottomHeight = topicTotalHeight - canFillHeight;
        topHeight = currentTopicStackList[i].initDragHeight - bottomHeight; // 为了预览的时候和边框距离 13px统一
        topHeight = topHeight <= 0 ? 1 : topHeight;// 这里topHeight小于0 的话 会出现下一页没有题型的bug          
        try {
          const temporaryDiv = document.createElement('div');// 临时构建一个div实例
          temporaryDiv.id = 'myTemporaryDiv';
          temporaryDiv.style.lineHeight = '38px';
          // temporaryDiv.style.opacity = '0';
          temporaryDiv.style.maxWidth = getContentWidth() + 'px';
          temporaryDiv.style.width = getContentWidth() + 'px';
          temporaryDiv.innerHTML = currentTopicStackList[i].innerHTML;
          document.body.append(temporaryDiv);
          let realDomHeight = 0;
          let realDomIndex = 0;
          const arrayElements = Array.from(temporaryDiv.childNodes);
          Array.from(arrayElements) && Array.from(arrayElements).forEach((child: any, index: number) => {
            const stepRealDomHeight = (child.offsetHeight <= TAG_P_HEIGHT ? TAG_P_HEIGHT : child.offsetHeight);
            realDomHeight += stepRealDomHeight;
            if (topHeight > realDomHeight + PADDING_TOP) {
              realDomIndex = realDomIndex + 1;
            }
          })
          let topEls = arrayElements.splice(0, realDomIndex);
          let bottomEls = arrayElements;
          topEls.forEach((item: any) => {
            topHTML += item.outerHTML || '';
          })
          bottomEls.forEach((item: any) => {
            bottomHTML += item.outerHTML || '';
            bottomElsHeight += item.offsetHeight || 38;
          });
          document.body.removeChild(temporaryDiv); // 销毁div实例
        } catch (e) {
          console.error('surplusHeightComputed方法报错', e.message);
        }
        break;
      }
    }
    bottomHeight = bottomHeight < bottomElsHeight ? bottomElsHeight + MARGIN_BOTTOM : bottomHeight + MARGIN_BOTTOM;
    return {
      fillIndex: fillIndex,
      topicTotalHeight: topicTotalHeight,
      topicTotalFillHeight: topicTotalFillHeight,
      bottomHeight: bottomHeight,
      topHeight: topHeight,
      bottomHTML: bottomHTML,
      topHTML: topHTML,
    };
  }

  removeSurplusStackWhenFirstInitCurtPage(state: any, page: number) {
    if (page == this.currentPage) {
      // this.currentPage用来区别递归增加的页码还是没有超过高度增加的
      state.pageCell[page].fillTopiclist = state.existStack;
    }
  }

  /**
   * 在下一页的头栈插入多出的高度
   */
  insertNextPageHeadStack(no: any, nextPageCell: any, overstepDistance: any, innerHTML?: string, xth?: string, sub?: { isSub: boolean }, lastStack?: any) {
    // nextPageCell.items.push({
    //   type: state.topticType || 1,
    // });
    nextPageCell.fillTopiclist.unshift({
      ...this,
      no: no,
      xth: xth,
      type: this.type,
      isHurdle: false, //当前item是否属于跨栏内容
      isResolved: false, // 题型是否分解
      isSub: (sub || { isSub: true }).isSub, // 是否由拖拽生成的子题型stack
      initDragHeight: overstepDistance,
      innerHTML: innerHTML || '',
      hasTitle: lastStack.hasTitle
    });
  }
}


